import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    standalone: false,
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
  width: 100%;
}`],
})
export class LayoutSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public authorized: boolean = false;
    public theme: 'light' | 'dark' = 'light';

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.check()) {
            location.href = "/access";
            return;
        }
        this.authorized = true;
        try {
            const saved = localStorage.getItem('appTheme');
            if (saved === 'dark' || saved === 'light') this.theme = saved;
        } catch (e) {}
        await this.service.render();
    }

    public async toggleTheme() {
        this.theme = this.theme === 'dark' ? 'light' : 'dark';
        try { localStorage.setItem('appTheme', this.theme); } catch (e) {}
        await this.service.render();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', false);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }
}

export default LayoutSidebarComponent;